import {InjectionToken} from '@angular/core';
import type {DeliverableId} from '../dex-streaming/types/deliverable';

export interface BalanceFetchingTriggerEvent {
    wAddresses?: string[];
    dIds?: DeliverableId[];
}

export interface BalanceFetchingTrigger {
    notifyUpdates: (event: BalanceFetchingTriggerEvent) => void;
}

export const BALANCE_FETCHING_TRIGGER = new InjectionToken<BalanceFetchingTrigger>('BALANCE_FETCHING_TRIGGER');

